import { combineReducers } from 'redux'

import { CARETEAMS_RECEIVED, CARETEAM_RECEIVED } from './actions'

const allIds = (state = [], action) => {
  const { type, payload } = action
  switch (type) {
    case CARETEAMS_RECEIVED:
      if (payload == null) throw new Error('No careteams')
      return [...state, ...payload.map(careteams => careteams.id)]
    case CARETEAM_RECEIVED:
      if (payload == null) throw new Error('No careteam')
      return [...state, payload.id]
    default:
      return state
  }
}

const byId = (state = {}, action) => {
  const { type, payload } = action
  switch (type) {
    case CARETEAMS_RECEIVED:
      return {
        ...state,
        ...payload.reduce(
          (s, careteam) => ({
            ...s,
            [careteam.id]: careteam
          }),
          {}
        )
      }
    case CARETEAM_RECEIVED:
      return {
        ...state,
        [payload.id]: { ...payload }
      }
    default:
      return state
  }
}

export default combineReducers({
  allIds,
  byId
})

export const getAllCareTeams = state =>
  state.careteams.allIds.map(id => state.careteams.byId[id])

export const getCareteamsFromPatientId = (state, patientId) =>
  getAllCareTeams(state).filter(
    careteam =>
      careteam.subject &&
      careteam.subject.identifier &&
      careteam.subject.identifier.value === patientId
  )



// WEBPACK FOOTER //
// ./src/Careteam/ducks.js